import React from 'react';
import FormControl from "./FormControl";
import { Input } from 'reactstrap';

const FormInput = (props) => {
    const { type, autoFocus, validations, register, ...rest } = props;
    const { name, id } = rest;
    const { ref, ...regRest } = register(name, validations);

    return (
        <FormControl
            {...rest}
            render={({ inputClass }) =>
                <Input
                    autoFocus={autoFocus && true}
                    className={inputClass}
                    name={name}
                    id={id || name}
                    type={type ?? "text"}
                    innerRef={ref}
                    {...regRest}
                />
            }
        />
    );
}

export default FormInput;